// extracted by mini-css-extract-plugin
export default {"header":"styles_header__M4h-v","tab":"styles_tab__ESBF4","activeTab":"styles_activeTab__qGDWm"};